export default __webpack_public_path__ + "static/media/acceso-camara-mac-4.1c406427.svg";